import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectItem} from 'primeng/api';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-select-langue',
    templateUrl: './select-langue.component.html',
    styleUrls: ['./select-langue.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectLangueComponent
        }
    ],
    standalone: false
})
export class SelectLangueComponent implements OnInit, ControlValueAccessor {

    @Input() disabled = false;
    @Input() value: SelectItem;
    @Output() changeLangue = new EventEmitter<SelectItem>();

    @Input() onlyInput = true;

    list: SelectItem[] = [];
    touched = false;

    constructor() {
    }

    ngOnInit(): void {
        this.list = ['FR', 'EN', 'IT', 'DE', 'NL', 'ES'].map(lg =>
            ({label: lg, value: lg} as SelectItem)
        );
      this.value = this.list[0];
  }

    onChange: any = () => { /**/ };
    onTouched: any = () => { /**/ };
    writeValue(item: any): void {
        this.value = item;
    }
    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    langueChange() {
        this.changeLangue.emit(this.value);
        this.onChange(this.value.value);
        this.onTouched(this.value.value);
    }
}
